/* eslint-disable no-unused-vars */
import { teal, blueGrey } from "@mui/material/colors";
import { Card, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PoleDisplayUtils } from "../../utils/PoleDisplayUtils";
import { PricingUtils } from "../../utils/PricingUtils";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { format, compareAsc } from "date-fns";

export default function MServiceSummary(props) {
  const { t } = useTranslation();
  const translate = t;

  const [srEta, setSrEta] = useState("");

  useEffect(() => {
    console.log(">>>", props.srEta);
    if (props.srEta) {
      format(new Date(2014, 1, 11), "MM/dd/yyyy");
      setSrEta(format(Date.parse(props.srEta), "dd:MM:yyyy"));
    } else {
      setSrEta("");
    }
  }, [props.srEta]);

  return (
    <div
      style={{
        paddingBottom: 5,
      }}
    >
      <Card>
        <Grid
          container
          style={{ background: blueGrey[500], color: "#fff", padding: 3 }}
        >
          <Grid item xs={11}>
            <Grid container>
              <Grid
                item
                xs={3}
                style={{ background: blueGrey[500], color: "#fff" }}
              >
                <Typography
                  variant="h8"
                  style={{
                    paddingLeft: 10,
                    paddingTop: 10,
                    textAlign: "left",
                  }}
                >
                  {translate("SR #")}
                </Typography>
              </Grid>
              <Grid
                item
                xs={3}
                style={{ background: blueGrey[500], color: "#fff" }}
              >
                <Typography
                  variant="h8"
                  style={{
                    paddingLeft: 10,
                    paddingTop: 10,
                    textAlign: "left",
                  }}
                >
                  {props.srNumber}
                </Typography>
              </Grid>

              <Grid
                item
                xs={2}
                style={{ background: blueGrey[500], color: "#fff" }}
              >
                <Typography
                  variant="h8"
                  style={{
                    paddingLeft: 10,
                    paddingTop: 10,
                    textAlign: "left",
                  }}
                >
                  {translate("Status")}
                </Typography>
              </Grid>
              <Grid
                item
                xs={4}
                style={{ background: blueGrey[500], color: "#fff" }}
              >
                <Typography
                  variant="h8"
                  style={{
                    paddingLeft: 10,
                    paddingTop: 10,
                    textAlign: "left",
                  }}
                >
                  {props.srStatus ? props.srStatus.name : "Open"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={3}
                style={{ background: blueGrey[500], color: "#fff" }}
              >
                <Typography
                  variant="h8"
                  style={{
                    paddingLeft: 10,
                    paddingTop: 10,
                    textAlign: "left",
                  }}
                >
                  {props.srAssigneeLabel}
                </Typography>
              </Grid>
              <Grid
                item
                xs={3}
                style={{ background: blueGrey[500], color: "#fff" }}
              >
                <Typography
                  variant="h8"
                  style={{
                    paddingLeft: 10,
                    paddingTop: 10,
                    textAlign: "left",
                  }}
                >
                  {props.srAssignee ? props.srAssignee.name : ""}
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                style={{ background: blueGrey[500], color: "#fff" }}
              >
                <Typography
                  variant="h8"
                  style={{
                    paddingLeft: 10,
                    paddingTop: 10,
                    textAlign: "left",
                  }}
                >
                  {translate("ETA")}
                </Typography>
              </Grid>
              <Grid
                item
                xs={4}
                style={{ background: blueGrey[500], color: "#fff" }}
              >
                <Typography
                  variant="h8"
                  style={{
                    paddingLeft: 10,
                    paddingTop: 10,
                    textAlign: "left",
                  }}
                >
                  {srEta}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={1}>
            <Grid xs={12}>
              <IconButton
                onClick={() => {
                  props.setCurrentScreen("edit_service_summary");
                }}
              >
                <EditIcon style={{ color: "#fff" }}></EditIcon>
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
}
